import { CVLayout } from "./components/CV";

// Importar i18n (registra las traducciones)
import "./i18n";

function App() {
  return <CVLayout />;
}

export default App;
